"use client";

import { useEffect } from "react";

// Needed because iOS 100vh is unusable
const setViewHeight = () => {
	const vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty("--vh", `${vh}px`);
};

export const ViewHeightProvider = () => {
	useEffect(() => {
		if (typeof window !== "undefined") {
			setViewHeight();
			window.addEventListener("resize", setViewHeight);

			return () => {
				window.removeEventListener("resize", setViewHeight);
			};
		}
	}, []);

	return null;
};
